import { PlayCircle, Map as MapIcon, Clock } from 'lucide-react';

const MiniCard = ({ icon, title }) => (
  <div className="bg-gray-50/50 border border-gray-100 p-3 rounded-2xl flex flex-col items-center gap-2">
    <div className="text-teal-500">{icon}</div>
    <span className="text-[9px] font-black text-gray-500 uppercase tracking-widest leading-none">
      {title}
    </span>
  </div>
);

const FeatureMiniCards = () => {
  return (
    <div className="grid grid-cols-3 gap-3 mt-12 max-w-2xl w-full">
      <MiniCard icon={<PlayCircle size={18} />} title="Pre-Reels" />
      <MiniCard icon={<MapIcon size={18} />} title="Map Story" />
      <MiniCard icon={<Clock size={18} />} title="Story Mode" />
    </div>
  );
};

export default FeatureMiniCards;
